import { useEffect, useMemo, useState } from 'react';

import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';
import { Grid, Button, Dialog, Stack, DialogTitle, DialogContent, DialogActions, IconButton, Box, Fab, Paper, Typography, ButtonGroup } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FilterAlt from '@mui/icons-material/FilterAlt';
import NextIcon from '@mui/icons-material/NextWeek';
import { FiltroUtil } from '@datatox-bi/util';
import { DynamicFilter } from '../Filter/DynamicFilter';
import { useLazyQuery } from '@apollo/client';
import { GERAR_DATASET_MONGO } from '../../requests/graphql';
import { DashboardContainer } from './DashboardContainer';

import TitleCube from './Title/TitleCube';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { NavLink } from 'react-router-dom';

// styles
const useStyles = makeStyles(() => ({
    button: {
        margin: '8px',
    },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const GridRowCharts = ({
    resultCharts,
    onResultObj,
    charts,
    primeiraConsultaAutomatica = false,
    executarConsultaFn,
    called,
    loading,
    data,
    filtrosSecundarios,
}) => {
    useEffect(() => {
        if (primeiraConsultaAutomatica) {
            executarConsultaFn();
        }
    }, []);

    function dadosNaoEncontrados() {
        // setOpenAlert(true, 'ALE001');
        return 'Dados não encontrados!';
    }

    const blockCharts = useMemo(() => {
        let chartView = <span></span>;
        if (called && loading) {
            chartView = <span>Loading...</span>;
        } else if (data && data['iMongoDataset']) {
            const valid = data['iMongoDataset'].length > 1;
            chartView = valid ? (
                <DashboardContainer dataset={data['iMongoDataset']} options={charts} onResultObj={onResultObj} filtrosSecundarios={filtrosSecundarios} />
            ) : (
                dadosNaoEncontrados()
            );
        }
        return chartView;
    }, [called, loading, data, charts]);

    return (
        <Grid item xs={12}>
            {blockCharts}
            {resultCharts}
        </Grid>
    );
};

const PageControl = ({ configFiltroSecundario, ...props }) => (
    <Grid xs display="flex" justifyContent="center" alignItems="center" {...props} >
        {/* <IconButton size="large">
        <nex></nex>
    </IconButton> */}
        {/* <Button variant="contained" endIcon={<ArrowForwardIosIcon />}>
        Próxima Página
    </Button> */}
        <ButtonGroup disableElevation variant="contained" aria-label="Disabled button group">
            {configFiltroSecundario.backPage && (
                <NavLink to={configFiltroSecundario.backPage} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Button startIcon={<ArrowBackIosIcon />}>Voltar</Button>
                </NavLink>
            )}
            {configFiltroSecundario.nextPage && (
                <NavLink to={configFiltroSecundario.nextPage} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Button endIcon={<ArrowForwardIosIcon />}>Próxima</Button>
                </NavLink>
            )}
        </ButtonGroup>
    </Grid>
);

function DashboardMongo({
    title,
    filtrosSecundarios,
    configFiltroSecundario,
    setFiltrosSecundarios,
    resultCharts,
    onResultObj,
    disabledButton = false,
    openModal,
    preFiltrosServer = [],
}) {
    const [carregarDataset, { called, error, loading, data }] = useLazyQuery(GERAR_DATASET_MONGO, {
        fetchPolicy: 'network-only',
    });

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const executarConsultaFn = () => {
        const preFiltros = FiltroUtil.normalizeFiltros([...filtrosSecundarios, ...preFiltrosServer]);

        carregarDataset({
            variables: {
                cubo: configFiltroSecundario.cubo,
                atributos: configFiltroSecundario.atributosSelecionados,
                filtros: preFiltros.map((f) => ({
                    atributo: f.atributo,
                    tipoComponente: f.tipoComponente,
                    valor: f.valor,
                })),
                medidas: configFiltroSecundario.medidas,
            },
        });
    };

    const limparFiltroFn = () => {
        setFiltrosSecundarios(filtrosSecundarios.map((f) => ({ ...f, valor: '' })));
    }

    return (
        <Box component="section" sx={{ p: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <TitleCube title={title} cubo={configFiltroSecundario.cubo} />
                </Grid>

                <Grid container spacing={1} sx={{ width: '100%', backgroundColor: 'backgroundPainel.main', margin: 0, p: 1 }}>
                    <Grid xs={12} alignContent={'center'} alignItems={'center'}>
                        <Typography color="Black" sx={{ color: 'text.main' }} variant="h6" component="h6">
                            Filtros:
                        </Typography>
                    </Grid>
                    <DynamicFilter
                        filtros={filtrosSecundarios}
                        cubo={configFiltroSecundario.cubo}
                        metaAtributos={configFiltroSecundario.metaAtributos}
                        onChangeFilter={(filtroAlterado) => {
                            const novoFiltrosSecundarios = filtrosSecundarios.map((filtro) => {
                                if (filtro.key == filtroAlterado.key) {
                                    return filtroAlterado;
                                }
                                return filtro;
                            });
                            setFiltrosSecundarios(novoFiltrosSecundarios);
                        }}
                        preFiltros={FiltroUtil.normalizeFiltros(filtrosSecundarios)}
                        preFiltrosServer={configFiltroSecundario.preFiltrosServer}
                        executarConsultaFn={executarConsultaFn}
                        limparFiltroFn={limparFiltroFn}
                    />
                </Grid>
                {/* <Box onClick={handleOpen} sx={{ '& > :not(style)': { m: 1 }, position: 'fixed', bottom: 16, right: 16, zIndex: 1 }}>
                    <Fab color="primary" aria-label="add">
                        <FilterAlt />
                    </Fab>
                </Box> */}
                {/* <BootstrapDialog fullWidth onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                    <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                        Filtros
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent dividers>
                        <Stack spacing={1} sx={{ width: '100%' }}>
                            <DynamicFilter
                                filtros={filtrosSecundarios}
                                cubo={configFiltroSecundario.cubo}
                                metaAtributos={configFiltroSecundario.metaAtributos}
                                onChangeFilter={(filtroAlterado) => {
                                    const novoFiltrosSecundarios = filtrosSecundarios.map((filtro) => {
                                        if (filtro.key == filtroAlterado.key) {
                                            return filtroAlterado;
                                        }
                                        return filtro;
                                    });
                                    setFiltrosSecundarios(novoFiltrosSecundarios);
                                }}
                                preFiltros={FiltroUtil.normalizeFiltros(filtrosSecundarios)}
                            />
                        </Stack>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={() => executarConsultaFn()}>
                            Aplicar Filtro
                        </Button>
                    </DialogActions>
                </BootstrapDialog> */}
                {!loading && <PageControl configFiltroSecundario={configFiltroSecundario} sx={{ margin: 2 }} />}
                <GridRowCharts
                    resultCharts={resultCharts}
                    onResultObj={onResultObj}
                    charts={configFiltroSecundario.charts}
                    primeiraConsultaAutomatica={configFiltroSecundario.primeiraConsultaAutomatica}
                    executarConsultaFn={executarConsultaFn}
                    called={called}
                    loading={loading}
                    data={data}
                    filtrosSecundarios={filtrosSecundarios}
                />
                <PageControl configFiltroSecundario={configFiltroSecundario} sx={{ marginTop: 3 }} />
            </Grid>
        </Box>
    );
}

export default DashboardMongo;
